/**
 * Phonics Letter Xx — 课程数据配置
 * Story 1: 右上2单词 + 下部3句台词（英文+中文）
 * Story 2: 上视频下3句台词（英文，不要翻译）
 * Story 3: 右上2单词 + 下部3句台词（英文+中文）
 */

const MEDIA_BASE = '/media/phonics/xx';

export const letterDataXx = {
  letter: 'Xx',
  title: 'Phonics',
  subtitle: 'Letter Xx',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Xx.mp4`,
    poster: `${MEDIA_BASE}/cover.png`,
    startTime: 11,
    endTime: 93,
  },

  // Step 2: 4 格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4`, cover: `${MEDIA_BASE}/image8.png`, word: 'box',  wordCn: '盒子' },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4`, cover: `${MEDIA_BASE}/image9.png`, word: 'fox',  wordCn: '狐狸' },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4`, cover: `${MEDIA_BASE}/image10.png`, word: 'T. rex', wordCn: '霸王龙' },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4`, cover: `${MEDIA_BASE}/image11.png`, word: 'six',  wordCn: '六' },
  ],

  // Story sections
  storySections: [

    // Learn the Story (1) — 左视频右上2单词下边3句台词
    {
      label: 'Learn the Story (1)',
      layout: 'video-left-vocab-right',
      splitAt: 2,
      videos: [{ src: `${MEDIA_BASE}/video_story_1.mp4`, poster: `${MEDIA_BASE}/image13.png` }],
      lines: [
        // 右侧单词（2个）
        { en: "There's a...", cn: '有一个...', audioEn: `${MEDIA_BASE}/w_en_story1_theres_a.mp3`, audioCn: `${MEDIA_BASE}/w_cn_story1_theres_a.mp3` },
        { en: 'Cute',         cn: '可爱的',    audioEn: `${MEDIA_BASE}/w_en_story1_cute.mp3`,     audioCn: `${MEDIA_BASE}/w_cn_story1_cute.mp3` },
        // 视频下方台词（3句）
        { en: "What's in the box?",         cn: '盒子里有什么？',              audioEn: `${MEDIA_BASE}/story1_en_1.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3` },
        { en: "There's a fox in the box!",  cn: '盒子里有一只狐狸！',         audioEn: `${MEDIA_BASE}/story1_en_2.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3` },
        { en: 'Cute fox.',                   cn: '可爱的狐狸。',                audioEn: `${MEDIA_BASE}/story1_en_3.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3` },
      ],
    },

    // Learn the Story (2) — 上视频下3句台词（英文，不要翻译）
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_2.mp4`, poster: `${MEDIA_BASE}/image14.png` }],
      lines: [
        { en: "What's in the box?",              audioEn: `${MEDIA_BASE}/story2_en_1.mp3` },
        { en: "There's a T. rex in the box!",    audioEn: `${MEDIA_BASE}/story2_en_2.mp3` },
        { en: 'Cute T. rex!',                     audioEn: `${MEDIA_BASE}/story2_en_3.mp3` },
      ],
    },

    // Learn the Story (3) — 左视频右上2单词下边3句台词
    {
      label: 'Learn the Story (3)',
      layout: 'video-left-vocab-right',
      splitAt: 2,
      videos: [{ src: `${MEDIA_BASE}/video_story_3.mp4`, poster: `${MEDIA_BASE}/image15.png` }],
      lines: [
        // 右侧单词（2个）
        { en: 'There are 6...',               cn: '有6个...',           audioEn: `${MEDIA_BASE}/w_en_story3_there_are_6.mp3`, audioCn: `${MEDIA_BASE}/w_cn_story3_there_are_6.mp3` },
        { en: 'baby',                          cn: '小宝贝',             audioEn: `${MEDIA_BASE}/w_en_story3_baby.mp3`,        audioCn: `${MEDIA_BASE}/w_cn_story3_baby.mp3` },
        // 视频下方台词（3句）
        { en: "What's in the box?",            cn: '盒子里有什么？',        audioEn: `${MEDIA_BASE}/story3_en_1.mp3`, audioCn: `${MEDIA_BASE}/story3_cn_1.mp3` },
        { en: 'There are six eggs in the box!', cn: '盒子里有六个蛋！',     audioEn: `${MEDIA_BASE}/story3_en_2.mp3`, audioCn: `${MEDIA_BASE}/story3_cn_2.mp3` },
        { en: 'Six baby dinosaurs!',           cn: '六只小恐龙！',           audioEn: `${MEDIA_BASE}/story3_en_3.mp3`, audioCn: `${MEDIA_BASE}/story3_cn_3.mp3` },
      ],
    },

  ],

  coverBg: `${MEDIA_BASE}/image1.jpeg`,
  coverPoster: `${MEDIA_BASE}/cover.png`,
};

export default letterDataXx;
